import React from "react";
import PropTypes from "prop-types";
import { TableRow, Tooltip } from "@mui/material";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

import TableItem from "./TableItem";
import Percentage from "./Percentage";
import { ALERT } from "../constants/styleConstants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function TotalTableRow({ errorMessage, isTotalValid, total }) {
  return (
    <TableRow>
      <TableItem></TableItem>
      <TableItem></TableItem>
      <TableItem>Total:</TableItem>
      <TableItem>
        <Tooltip
          disableFocusListener={isTotalValid}
          disableHoverListener={isTotalValid}
          title={errorMessage}
        >
          <span style={{ color: isTotalValid ? "inherit" : ALERT }}>
            <Percentage decimalPlaces={3}>{total}</Percentage>
            {!isTotalValid && (
              <FontAwesomeIcon
                style={{ fontSize: "16px", marginLeft: "5px" }}
                icon={faExclamationCircle}
              />
            )}
          </span>
        </Tooltip>
      </TableItem>
    </TableRow>
  );
}

TotalTableRow.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  isTotalValid: PropTypes.bool.isRequired,
  total: PropTypes.number.isRequired,
};
